import { c as _c } from "react/compiler-runtime";
import { Button } from "@website/ui/button";
import { LazyImage } from "@website/ui/lazy-image";
import { VILLA_HOST_SUPPORT_PHONE_NUMBER } from "../villa-host.constants";
import type { VillaHostImageSource } from "../villa-host.types";
export const VillaHostSupportCard = t0 => {
  const $ = _c(5);
  const {
    image
  } = t0;
  let t1;
  if ($[0] !== image) {
    t1 = <LazyImage alt="" src={image} className="max-lg:w-12" />;
    $[0] = image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-6 max-lg:flex-col"><div><p className="pb-2 text-sm font-semibold lg:pb-4 lg:text-xl">پاسخ خود را پیدا نکردید؟</p><p className="text-on-surface-medium-emphasis text-xs font-medium lg:text-sm">کارشناسان اسنپ‌تریپ در انتظار کمک به شما هستند.</p></div><Button color="neutral" className="!h-9 !w-44 lg:!h-12" role="link" href={`tel:${VILLA_HOST_SUPPORT_PHONE_NUMBER}`}>تماس با پشتیبانی</Button></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <div className="flex items-start justify-center gap-2 rounded-2xl bg-gray-100 p-4 lg:items-center lg:gap-6 lg:p-9">{t1}{t2}</div>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};